import { all } from 'redux-saga/effects';

/* Session is pure client state (role + lang) — no async work. Kept as a saga
   module for parity with the 6-file convention and future wiring. */
export function* sessionSaga(): Generator {
  yield all([]);
}
